import React, { useEffect, useState } from "react";
import { useTokenStore } from "../../../../hooks";
import { supabaseApi } from "../../../../services";
import { logger } from "../../../../utils";
import { UserProfile } from "../../../../models";
import { Body1, Body1Strong, makeStyles, Spinner } from "@fluentui/react-components";
import { isString } from "lodash";

const useStyles = makeStyles({
  row: {
    display: "flex",
    flexDirection: "row",
    gap: "5px",
    marginBottom: "5px",
  },
});

export interface InformationRowProps {
  label: string;
  type: "user_profile" | "date" | "text";
  value?: Date | string;
}

export const InformationRow = ({ label, type, value }: InformationRowProps) => {
  // used to control component styles
  const styles = useStyles();

  // indicates the user profile associated with the userId parameter
  const [userProfile, setUserProfile] = useState<UserProfile | undefined>(undefined);

  useEffect(() => {
    if (type !== "user_profile") return;

    const fetchUserProfile = async (userId: string) => {
      try {
        const response = await supabaseApi.getUserProfileById(userId);
        if (response) setUserProfile(response);
      } catch (err) {
        logger.error("Error fetching user profile", err);
        setUserProfile(undefined);
      }
    };

    if (isString(value)) fetchUserProfile(value);
  }, [type, value]);

  if (type === "date" && value) {
    return (
      <div className={styles.row}>
        <Body1Strong>{label}</Body1Strong>
        <Body1>{new Date(value).toLocaleString()}</Body1>
      </div>
    );
  }

  if (type === "text" && isString(value)) {
    return (
      <div className={styles.row}>
        <Body1Strong>{label}</Body1Strong>
        <Body1>{value}</Body1>
      </div>
    );
  }

  if (type === "user_profile" && isString(value)) {
    return (
      <div className={styles.row}>
        <Body1Strong>{label}</Body1Strong>
        {userProfile ? (
          <Body1>
            {userProfile?.display_name
              ? userProfile.display_name
              : userProfile?.first_name && userProfile?.last_name
                ? `${userProfile?.first_name} ${userProfile?.last_name}`
                : userProfile?.login_email}
          </Body1>
        ) : (
          <Body1>
            <Spinner size="small" />
          </Body1>
        )}
      </div>
    );
  }

  return null;
};
